module.exports = __webpack_public_path__ + "img/logo.a6ed9943.svg";